const backend = [
    "Building server-side architecture",
    "Developing APIs",
    "Managing databases",
    "Implementing security measures",
    "Testing, debugging, and deploying",
    "Monitoring system performance",
];

const frontend =[
    "Implement Designs",
    "Code Responsiveness",
    "Interactivity",
    "Optimize Performance",
    "Cross-Browser Compatibility",
    "Testing and Debugging",
]

const design = [
    "Quality Assurance",
    "Documentation",
    "Staying Updated",
    "Conceptualizing Designs",
    "Implementing Designs",
    "Creating Mockups and Prototypes",
]

export { backend, frontend, design };